module.exports = {
      id: "dh-symbol-usage",
      viewBox: "0 0 344.84 299.91",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#dh-symbol",
      toString: function () {
        return this.url;
      }
    }